import './styles.styl'
import React from 'react'

export default class UIComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      username: '',
      password: '',
      remember: false
    }
  }

  componentDidMount () {
    const {
      loggedIn,
      loggingIn,
      didAttemptAutoLogin,
      attemptAutoLogin
    } = this.props

    if (!loggedIn && !loggingIn && !didAttemptAutoLogin) {
      attemptAutoLogin()
    }
  }

  login () {
    if (this.state.username === '' || this.state.password === '') {
      return
    }

    this.props
      .login(this.state.username, this.state.password, this.state.remember)
      .catch(err => {
        console.log(`[login] error: ${err.message}`)
      })
  }

  render () {
    let error = null

    if (typeof this.props.error === 'string' && this.props.error.trim() !== '') {
      error = (
        <div className='alert alert-danger'>
          {this.props.error}
        </div>
      )
    }

    return (
      <section className='content'>
        <div className='container'>
          <div className='row'>
            <div className='col-12 col-sm-3'>&nbsp;</div>
            <div className='col-12 col-sm-6'>
              <center style={{ paddingBottom: '5em' }}>
                <img src='/static/iloyalty.png' style={{ width: '200px', height: 'auto' }} alt='iLoyalty' />
              </center>

              {error}
              <div className='form-group'>
                <label className='form-label'>Username</label>
                <input className='form-control' type='text' value={this.state.username} onChange={e => this.setState({ username: e.target.value })} />
              </div>

              <div className='form-group'>
                <label className='form-label'>Password</label>
                <input className='form-control' type='password' value={this.state.password} onChange={e => this.setState({ password: e.target.value })} />
              </div>

              <div className='form-group'>
                <div className='form-check'>
                  <input type='checkbox' id='remember' className='form-check-input' value={this.state.remember} onChange={e => this.setState({ remember: e.target.checked })} />
                  <label className='form-check-label' htmlFor='remember'>Onthouden</label>
                </div>
              </div>

              <div className='form-group'>
                <button className='btn btn-primary' onClick={() => this.login()}>Inloggen</button>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./ui/login/component.js